/** Typy wspólne dla wszystkich domen i aplikacji. */

export const LOCALES = ["pl", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

export type Platform = "ios" | "android" | "web";

/** Rynek w rozumieniu marketingowym (§32) — kod kraju ISO 3166-1 alpha-2. */
export type Market = string;
